<template>
    <div class="vh-100">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="back_FR">
                    <div class="header-item">
                        <img src="../../../assets/img/x2.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Atur Periode Absen</div>
                <div class="header-top--right">
                    <div class="header-item">
                        <!-- <img src="../../assets/icons/search.svg" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper bg-white">
	        <div class="flex-100 main-page">

		    <div class="flex-1">
			    <div class="p-x-20 p-y-16 w-limit">
			        <label for="BtnYearFR" class="form-label">Jenis Periode:</label>
			        <div class="radio-group">
				        <div class="radio-wrapper">
					        <div class="radio-item" @click="clickradiobutton_FR">
						        <input type="radio" id="BtnYearFR" name="radioboxxFR" class="year"
						               v-model="Jenis_Periode_FR">
						        <label for="BtnYearFR">Tahun</label>
					        </div>
					        <div class="radio-item" @click="defaultpage_FR">
						        <input type="radio" id="BtnMonthFR" name="radioboxxFR" v-model="Jenis_Periode_FR">
						        <label for="BtnMonthFR">Bulan</label>
					        </div>
					        <div class="radio-item" @click="clickradiobuttontanggal_FR">
						        <input type="radio" id="BtndateFR" name="radioboxxFR" v-model="Jenis_Periode_FR">
						        <label for="BtndateFR">Tanggal</label>
					        </div>
				        </div>
			        </div>
		        </div>
		        <div class="separator"></div>


                <div class="w-limit p-x-20">
                    <div class="form-group mod m-t-16" id="tahunFR">
                        <label for="input_tahunFR" class="form-label">Tahun</label>
                        <input type="text" class="form-control yearpicker" id="input_tahunFR"
                               placeholder="Ketuk untuk menyetel..." v-model="input_date_year_FR"
                               @change="chekvalidate_FR"
                               value="" readonly>
                    </div>
                    <div class="form-group mod p-t-16" id="monthFR">
                        <label for="input_BulananFR" class="form-label">Bulan</label>
                        <input type="month" class="form-control" id="input_BulananFR"
                               placeholder="Ketuk untuk menyetel..." v-model="input_date_month_FR"
                               @change="cekinputbulan_FR">
                    </div>
                    <div class="form-group mod p-t-16" id="firstdateFR">
                        <label for="input_awalFR" class="form-label">Tanggal Awal</label>
                        <input type="date" class="form-control" id="input_awalFR"
                               placeholder="Ketuk untuk menyetel..." v-model="input_date_awal_FR"
                               @change="cekinputanDay_FR">
                    </div>
                    <div class="form-group mod p-t-16" id="lastdateFR">
                        <label for="input_akhirFR" class="form-label">Tanggal Akhir</label>
                        <input type="date" class="form-control" id="input_akhirFR"
                               placeholder="Ketuk untuk menyetel..." v-model="input_date_akhir_FR"
                               @change="cekinputanDay_FR">
                    </div>
                </div>
            </div>
		    <div class="button-wrapper p-x-20 p-t-24 p-d-20 w-limit w-100">
			    <button class="btn smart-primary" @click="PeriodeYear_FR" id="BtnYearsFR">Terapkan</button>
			    <button class="btn smart-primary" @click="PeriodeMonth_FR" id="BtnMonthsFR" disabled>Terapkan</button>
			    <button class="btn smart-primary" @click="PeriodeDay_FR" id="BtnDayFR" disabled>Terapkan</button>
		    </div>
	        </div>

            <div id="loadingPages" style="display: none">
                <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PeriodeAbsen_FromRekap",
        data() {
            return {
                Jenis_Periode_FR: '',
                input_date_month_FR: '',
                input_date_year_FR: '',
                input_date_awal_FR: '',
                input_date_akhir_FR: '',
                max_month_FR: '',
                List_Absen_Year_FR: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        props: ['datarekaptoperiode', 'periode_absen'],
        mounted() {
            this.defaultpage_FR();
            this.todayMonth_FR();
            this.cekinputbulan_FR();
        },

        methods: {
            // <!-- Fungsi BACK TO LIST -->
            back_FR() {
                this.$emit('back');
            },

            // <!-- Fungsi BACK TO LIST -->
            defaultpage_FR() {
                $('#tahunFR').hide();
                $('#firstdateFR').hide();
                $('#lastdateFR').hide();
                $('#monthFR').show();
                $('#BtnYearsFR').hide();
                $('#BtnDayFR').hide();
                $('#BtnMonthsFR').show();
                $("#BtnMonthFR").prop("checked", true);
                this.Jenis_Periode_FR = 'by_bulan';


            },

            clickradiobutton_FR() {
                $("#BtnYearFR").prop("checked", true);
                this.Jenis_Periode_FR = 'by_tahun'
                $('#tahunFR').show();
                $('#firstdateFR').hide();
                $('#lastdateFR').hide();
                $('#monthFR').hide();
                $('#BtnYearsFR').show();
                $('#BtnDayFR').hide();
                $('#BtnMonthsFR').hide();
                this.setdateyears_FR();
                this.todayyears_FR();
                this.cekinputbulan_FR();

            },

            clickradiobuttontanggal_FR() {
                $("#BtndateFR").prop("checked", true);
                this.Jenis_Periode_FR = 'by_tanggal';
                $('#tahunFR').hide();
                $('#firstdateFR').show();
                $('#lastdateFR').show();
                $('#monthFR').hide();
                $('#BtnYearsFR').hide();
                $('#BtnDayFR').show();
                $('#BtnMonthsFR').hide();
                this.setdatefirstday_FR();
                this.todayfirstday_FR();
                this.setdatelastday_FR();
                this.todaylastday_FR();
                this.cekinputanDay_FR();
            },

            cekinputbulan_FR() {
                var selectLayanan = this.input_date_month_FR;
                if (selectLayanan !== '') {
                    $('#BtnMonthsFR').prop('disabled', false);
                } else {
                    $('#BtnMonthsFR').prop('disabled', true);
                }
            },

            cekinputanDay_FR() {
                this.setdatelastday_FR();
                var selectLayanan = this.input_date_awal_FR;
                var selectLayanan1 = this.input_date_akhir_FR;
                $('#input_awalFR').attr('max', this.input_date_akhir_FR);
                if (selectLayanan !== '' && selectLayanan1 !== '') {
                    $('#BtnDayFR').prop('disabled', false);
                } else {
                    $('#BtnDayFR').prop('disabled', true);
                }
            },

            setdatefirstday_FR() {
                $('#input_awalFR').attr('max', this.input_date_awal_FR);
            },

            todayfirstday_FR() {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                this.input_date_awal_FR = today;
            },

            setdatelastday_FR() {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                $('#input_akhir').attr('min', this.input_date_awal_FR);
                $('#input_akhir').attr('max', today);

            },

            todaylastday_FR() {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                this.input_date_akhir_FR = today;
            },

            todayMonth_FR() {
                this.input_date_month_FR = this.$moment().format("YYYY-MM");
                $('#input_BulananFR').attr('max', this.$moment().add(1, 'months').format("YYYY-MM"));
            },

            setdateyears_FR() {
                $('#input_tahunFR').attr('max', this.input_date_year_FR);
            },

            todayyears_FR() {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = yyyy;
                this.input_date_year_FR = today;

                $(".yearpicker").yearpicker({
                    endYear: this.input_date_year_FR,
                    selectedClass: 'selected',
                });

                this.chekvalidate_FR()


            },

            chekvalidate_FR() {
                $(".yearpicker-container").click(function () {
                    $("#input_tahunFR").val()
                    setTimeout(function () {
                    }, 1000)


                })
            },

	        async PeriodeYear_FR() {
		        this.periode_absen.filter_by = "year"
		        this.periode_absen.year = $("#input_tahunFR").val()
		        this.$emit("setPeriodeAbsen", this.periode_absen)
	        },

	        async PeriodeDay_FR() {
		        this.periode_absen.filter_by = "periode"
		        this.periode_absen.start_date = this.input_date_awal_FR
		        this.periode_absen.end_date = this.input_date_akhir_FR
		        this.$emit("setPeriodeAbsen", this.periode_absen)
	        },


	        async PeriodeMonth_FR() {
		        this.periode_absen.filter_by = "month"
		        this.periode_absen.month = this.input_date_month_FR
		        this.$emit("setPeriodeAbsen", this.periode_absen)
	        },

            // async PeriodeYear_FR() {
            //     var years = $("#input_tahunFR").val()
            //     $('#loadingPages').show();
            //     $('#loadingPages').addClass('overlayLoading');
            //     try {
            //         const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_by_year?tahun=' + years, this.requestHeaders);
            //         if (res.status === 200) {
            //             if (res.data.status === true) {
            //                 $('#loadingPages').hide();
            //                 $('#loadingPages').removeClass('overlayLoading');
            //                 var respon = res.data;
            //                 this.datarekaptoperiode.filterby = respon.periode.periode;
            //                 this.datarekaptoperiode.valuemonth = respon.periode.periode_value_1;
            //                 this.$emit('isdetail', respon);
            //             }
            //         } else {
            //             $('#loadingPages').hide();
            //             $('#loadingPages').removeClass('overlayLoading');
            //             this.$toast.error(response.data.msg)
            //         }
            //     } catch (e) {
            //         this.$catch_error_response(e)
            //         $('#loadingPages').hide();
            //         $('#loadingPages').removeClass('overlayLoading');
            //     }
            // },
			//
            // async PeriodeDay_FR() {
            //     $('#loadingPages').show();
            //     $('#loadingPages').addClass('overlayLoading');
            //     try {
            //         const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_with_range_date?tanggal_mulai=' + this.input_date_awal_FR
            //             + '&tanggal_selesai=' + this.input_date_akhir_FR, this.requestHeaders);
            //         if (res.status === 200) {
            //             if (res.data.status === true) {
            //                 $('#loadingPages').hide();
            //                 $('#loadingPages').removeClass('overlayLoading');
            //                 var respon = res.data;
            //                 var data_akir = respon.periode.periode_value_2;
            //                 this.datarekaptoperiode.filterby = respon.periode.periode;
            //                 this.datarekaptoperiode.valueawal = respon.periode.periode_value_1;
            //                 this.datarekaptoperiode.valueakhir = respon.periode.periode_value_2;
            //                 this.$emit('isdetail', respon)
            //             } else {
            //                 $('#loadingPages').hide();
            //                 $('#loadingPages').removeClass('overlayLoading');
            //                 this.$toast.error(res.data.msg)
            //             }
            //         }
            //     } catch (e) {
            //         this.$catch_error_response(e)
            //         $('#loadingPages').hide();
            //         $('#loadingPages').removeClass('overlayLoading');
            //     }
            // },
			//
			//
            // async PeriodeMonth_FR() {
            //     $('#loadingPages').show();
            //     $('#loadingPages').addClass('overlayLoading');
            //     try {
            //         const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_by_month?bulan=' + this.input_date_month_FR, this.requestHeaders);
            //         if (res.status === 200) {
            //             if (res.data.status === true) {
            //                 $('#loadingPages').hide();
            //                 $('#loadingPages').removeClass('overlayLoading');
            //                 var respon = res.data;
            //                 this.datarekaptoperiode.filterby = respon.periode.periode;
            //                 this.datarekaptoperiode.valuemonth = respon.periode.periode_value_1;
            //                 this.$emit('isdetail', respon)
            //             } else {
            //                 this.$toast.error(res.data.msg)
            //                 $('#loadingPages').hide();
            //                 $('#loadingPages').removeClass('overlayLoading');
            //             }
            //         }
            //     } catch (e) {
            //         this.$catch_error_response(e)
            //         $('#loadingPages').hide();
            //         $('#loadingPages').removeClass('overlayLoading');
            //     }
            // },
        }
    }
</script>

<style scoped>

</style>